<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'FilterAsChips',
  props: {
    queryObject: { type: Object, required: true },
  },
});
</script>

<template>
  <Tag
    v-for="(k, v) in queryObject"
    :key="`fas${k}:${v}`"
    :value="`${v}: ${k}`"
  />
</template>

<style scoped></style>
